import { render, staticRenderFns } from "./TypeOfActivities.vue?vue&type=template&id=303d736a"
import script from "./TypeOfActivities.vue?vue&type=script&lang=js"
export * from "./TypeOfActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports